import Component from '../../classes/Component';
import Swiper, {EffectFade, Pagination, Navigation, Lazy} from 'swiper';
import variables from '../../variables';
import LazyLoad from 'vanilla-lazyload';
import {$dom} from '../../helpers/dom';
import {isElement} from '../../helpers/_utilities';

const {get, addClass, getAll, each, hasClass, getParent, remove} = $dom;

export default function introSection(rootId = 'js-home-intro') {

  const
    videoLazyReadyClassName = 'js-lazy-video-ready',
    videoSelector = '.js-video-lazy'
  ;

  const isVideoElement = el => isElement(el) && Boolean(el.play);
  const isPlaying = video => video.currentTime > 0 && !video.paused && !video.ended && video.readyState > video.HAVE_CURRENT_DATA;

  return new Component({
    name: 'homeIntro',
    requiredSelector: `#${rootId}`,
    rootElementId: rootId,
    onCreate() {
      this.carousel = null;
      this.videoLazyInstance = null;
    },
    onInit() {

      const runVideo = video => {
        each(getAll(videoSelector, `#${rootId}`).filter(v => v !== video), v => v.pause());

        (isVideoElement(video) && video.paused) && video.play()
      };

      this.videoLazyInstance = new LazyLoad({
        elements_selector: `.${videoLazyReadyClassName}`,
        class_loaded: variables.classNames.lazyLoaded,
        callback_loaded(video) {
          addClass(video, variables.classNames.lazyLoaded);
          runVideo(video);

          const slide = getParent(video, '.swiper-slide');

          if (isElement(slide)) {
            const preloaderEl = get(`.${variables.classNames.lazyPreloader}`, slide);

            if (isElement(preloaderEl)) remove(preloaderEl)
          }
        }
      });

      const toggleVideoPlay = swiper => {
        const video = get(videoSelector, swiper.slides[swiper.activeIndex]);

        if (isVideoElement(video)) {
          addClass(video, videoLazyReadyClassName);

          if (hasClass(video, variables.classNames.lazyLoaded)) {
            runVideo(video);
          }
        }

        this.videoLazyInstance.update();
      };

      this.carousel = new Swiper(`#${rootId} .swiper`, {
        speed: variables.carouselDefaultDuration,
        modules: [EffectFade, Pagination, Navigation, Lazy],
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        slideActiveClass: variables.classNames.active,
        pagination: {
          el: `#${rootId} .swiper-pagination`,
          type: 'bullets',
          dynamicBullets: true,
          clickable: true
        },
        navigation: {
          nextEl: `#${rootId} .swiper-button-next`,
          prevEl: `#${rootId} .swiper-button-prev`
        },
        preloadImages: false,

        lazy: {
          preloaderClass: variables.classNames.lazyPreloader,
          loadedClass: variables.classNames.lazyLoaded
        },
        on: {
          init: toggleVideoPlay,
          slideChange: toggleVideoPlay,
        }
      })
    },
    onDestroy() {
      if (this.carousel instanceof Swiper) {
        this.carousel.destroy();
        this.carousel = null;
      }

      if (this.videoLazyInstance instanceof LazyLoad) {
        this.videoLazyInstance.destroy();
        this.videoLazyInstance = null;
      }
    }
  })
}